<template>
  <div>
    <div
      v-show="loginHasErrors"
      id="login-errors-alert"
      class="alert alert-danger"
    >
      {{ $t('login.messages.error.authentication') }}
    </div>
    <form
      id="login-form"
      class="form"
      role="form"
      @submit.prevent="login()"
    >
      <user-name-login
        :user-name="credentials.username"
        @update-user-name-login="setUserName"
      />
      <div class="form-group">
        <tc-lock class="tc-icon fs-unmask" />
        <label
          class="fs-unmask"
          for="login-password"
        >
          {{ $t('login.form.password') }}
        </label>
        <div class="input-group">
          <input
            id="login-password"
            v-model="credentials.password"
            name="password"
            :type="passwordFieldType"
            class="form-control"
            :class="{'playback-hide': showPassword}"
            :placeholder="$t('login.form.passwordPlaceholder')"
          >
          <div class="icon-group">
            <tc-v-btn
              id="show-password-icon"
              icon
              @click="switchPasswordVisibility"
            >
              <v-icon class="eye-icon fs-unmask">
                {{ passwordVisibilityIcon }}
              </v-icon>
            </tc-v-btn>
          </div>
        </div>
        <tc-v-btn
          id="forgot-password"
          color="primary"
          text
          :to="{ name: 'ForgotPassword' }"
        >
          {{ $t('login.form.forgotPassword') }}
        </tc-v-btn>
      </div>
      <tc-v-btn
        id="login-submit-button"
        class="btn-primary"
        type="submit"
        :disabled="!formIsValid"
      >
        {{ $t('login.form.button') }}
      </tc-v-btn>
    </form>
  </div>
</template>

<script>
import { APP_SET_LOADING } from '@/store/mutation-types'
import { LOGIN_CLICKED } from '@/components/shared/segment/track-user-management'
import AuthenticationProvider from '@/components/shared/security/authentication-provider'
import TcLock from '@/components/shared/icons/TcLock'
import UserNameLogin from './UserNameLogin'

export default {
  name: 'PasswordLogin',
  components: {
    TcLock,
    UserNameLogin
  },
  props: {
    defaultUserName: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      credentials: {
        username: this.defaultUserName,
        password: null,
        rememberMe: false
      },
      loginHasErrors: false,
      passwordFieldType: 'password'
    }
  },
  computed: {
    showPassword () {
      return this.passwordFieldType !== 'password'
    },
    formIsValid () {
      return !this.errors.items.length && this.credentials.username && this.credentials.password
    },
    passwordVisibilityIcon () {
      return this.showPassword ? 'tci-eye-slash' : 'tci-eye'
    }
  },
  methods: {
    async login () {
      this.$store.commit(APP_SET_LOADING, true)
      this.$segment.track(LOGIN_CLICKED)

      try {
        const response = await AuthenticationProvider.authenticate(this.credentials)
        switch (response.status) {
          case 'SUCCESS':
            this.$router.push({ name: 'MfaReturn' })
            break
          case 'EXPIRED':
            this.$router.push({ name: 'ExpiredPasswordComponent', params: { username: this.credentials.username } })
            break
          default:
            this.loginHasErrors = true
            break
        }
      } catch (err) {
        this.loginHasErrors = true
      } finally {
        this.$store.commit(APP_SET_LOADING, false)
      }
    },
    switchPasswordVisibility () {
      this.passwordFieldType = this.showPassword ? 'password' : 'text'
    },
    setUserName (username) {
      this.credentials.username = username
    }
  }
}
</script>

<style scoped lang="scss">
  @import 'Login';
  #forgot-password {
    padding-left: 0px;
  }

  #show-password-icon {
    top: 6px;
  }

  .eye-icon {
    top: -1px;
  }
  .btn-primary {
    width: 100%;
  }
</style>
